import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";

// Debounced live price quote. Recomputes whenever the relevant fields change.
export function useLiveQuote({ carId, form, appliedCode, onCodeError }) {
  const [quote, setQuote] = useState(null);
  const [quoteError, setQuoteError] = useState("");
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!form.pickup_date || !form.return_date || !form.date_of_birth) {
      setQuote(null);
      setQuoteError("");
      return;
    }
    if (debounceRef.current) clearTimeout(debounceRef.current);
    let ignore = false;
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await api.post("/bookings/quote", {
          car_id: carId,
          date_of_birth: form.date_of_birth,
          pickup_date: form.pickup_date,
          return_date: form.return_date,
          pickup_location: form.pickup_location,
          refundable: form.refundable,
          airport_dropoff: form.airport_dropoff,
          unlimited_miles: form.unlimited_miles,
          discount_code: appliedCode,
        });
        if (ignore) return;
        setQuote(res.data);
        setQuoteError("");
        if (appliedCode && res.data.discount_error) onCodeError(res.data.discount_error);
      } catch (err) {
        if (ignore) return;
        setQuote(null);
        setQuoteError(formatApiError(err.response?.data?.detail));
      }
    }, 400);
    return () => { ignore = true; if (debounceRef.current) clearTimeout(debounceRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carId, form.pickup_date, form.return_date, form.date_of_birth, form.refundable, form.airport_dropoff, form.unlimited_miles, appliedCode]);

  return { quote, quoteError };
}
